import { Directive, EventEmitter, HostListener, Input, OnInit, Output } from "@angular/core";

import { EventEmitterHelper } from "@tylertech/shared-module";

import { AttachmentModel } from "../interfaces";
import { AttachmentService } from "../services";

@Directive({
    selector: "[dragAndDrop]",
    standalone: false
})
export class DragAndDropDirective
    implements OnInit
{
    @Input() readonly dragAndDrop: boolean;

    @Output("dropped") readonly dropEvent = new EventEmitter<Array<AttachmentModel>>();

    protected promise?: Promise<void>;

    constructor(
        private readonly $attachmentService: AttachmentService)
    { }

    ngOnInit(): void
    {
        if (!EventEmitterHelper.hasSubscribers(this.dropEvent))
        {
            throw "Require method onDrop missing on DragAndDropDirective";
        }
    }

    @HostListener("dragover", ["$event"])
    onDragover($event: Event): void
    {
        if (!this.dragAndDrop)
        {
            return;
        }

        $event.preventDefault();
        $event.stopPropagation();
    }

    @HostListener("dragenter", ["$event"])
    onDragenter($event: Event): void
    {
        if (!this.dragAndDrop)
        {
            return;
        }

        $event.preventDefault();
        $event.stopPropagation();
    }

    @HostListener("drop", ["$event"])
    onDrop($event: DragEvent): void
    {
        if (!this.dragAndDrop)
        {
            return;
        }

        $event.preventDefault();
        $event.stopPropagation();

        if (!$event.dataTransfer
            || !$event.dataTransfer.files
            || $event.dataTransfer.files.length <= 0)
        {
            return;
        }

        const files = Array.from($event.dataTransfer.files);
        this.parseFiles(files);
    }

    private parseFiles(files: Array<File>): void
    {
        this.promise = this.$attachmentService.ConvertToAttachments(files)
            .then(result =>
            {
                this.dropEvent.emit(result);
            })
            .finally(() =>
            {
                this.promise = undefined;
            });
    }
}
